export default __webpack_public_path__ + "reason.7acf6416.png";